// 产品推荐管理
import http from "@/jslibs/axios/http";

// 产品推荐列表
export const list = (data) => http.get("/v1/cms/GoodsRecommend", data);

// 产品推荐新增
export const add = (data) => http.post("/v1/cms/GoodsRecommend", data);

// 产品推荐上移
export const up = ({ uuid }) => http.put(`/v1/cms/GoodsRecommend/moveup/${uuid}`);

// 产品推荐下移
export const down = ({ uuid }) => http.put(`/v1/cms/GoodsRecommend/movedown/${uuid}`);

// 产品推荐删除
export const del = ({ uuid }) => http.delete(`/v1/cms/GoodsRecommend/${uuid}`);